module.exports = __webpack_public_path__ + "img/9788952211705.9486286e.jpg";